import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useAttribution } from 'app/components/analytics-attribution/useAttribution'
import { AttributionShadcnComponent } from 'app/components/analytics-attribution/AttributionShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle, useFeatureToggleState } from 'app/hooks/useFeatureToggle'
import { UserPermissionsContext } from 'app/hooks/useUserPermission'
import { useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'

export default observer(function Attribution() {
  const user = useUser()
  const staffV2 = useFeatureToggleState(`staff-v2`)
  const attributionEnabled = useFeatureToggle(`attribution`)
  const attributionV2Enabled = useFeatureToggle(`attribution-v2`)
  const checkPermission = useCheckPermission()
  const { permissions } = useContext(UserPermissionsContext)
  const hookData = useAttribution()

  if (!user) return null

  // SMC orgs never have access to attribution
  if (isSMCOrg(user.orgId)) {
    return <Navigate to="/" replace />
  }

  // Feature toggles load asynchronously and default to `false` before they
  // resolve. Evaluating the guards below on that premature `false` sends the
  // user to `/` or `/analytics/marketing` on refresh (TRK-5546). Wait for the
  // store to finish loading before evaluating any toggle-based guard.
  if (!staffV2.settled) return null

  if (staffV2.enabled) {
    if (permissions === undefined) return null // Wait for permissions to load
    if (!checkPermission([`org:pages:analytics:attribution`, `pages:analytics`])) {
      return <Navigate to="/analytics/marketing" replace />
    }
  } else {
    // Legacy: check attribution feature toggle
    if (!attributionEnabled) {
      return <Navigate to="/" replace />
    }
  }

  return <AttributionShadcnComponent {...hookData} />
})
